// @flow
import { call, put, takeLatest } from 'redux-saga/effects';
import { CONFIG, GET_POWER_CONSUMPTION, PLATFORM } from './constants';

import { app as appApi } from '~/core/api';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';
import type { Effect } from 'redux-saga';
import { noop } from 'lodash/fp';
import { receivePowerConsumption } from './actions';

export function* getPowerConsumptionConfig(): Generator<noop | Effect, *, *> {
    const [response, error] = yield call(handleApi(appApi.getAppConfig), PLATFORM, CONFIG);
    yield put(receivePowerConsumption(error || response));
}

function* watchGetPowerConsumptionConfig(): Generator<Effect, *, *> {
    yield takeLatest(GET_POWER_CONSUMPTION, handleSaga(getPowerConsumptionConfig));
}

export default [watchGetPowerConsumptionConfig];



// WEBPACK FOOTER //
// ./src/core/state/power-consumption/sagas.js